import {EntityState} from '@ngrx/entity';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import {MixEntity} from '@spout/any-shared/models';

export interface MixState extends EntityState<MixEntity> {
  // additional entities state properties
  loaded: boolean;
}
